import { render, staticRenderFns } from "./AppEditPostback.vue?vue&type=template&id=f5bd6cae&scoped=true"
import script from "./AppEditPostback.vue?vue&type=script&lang=js"
export * from "./AppEditPostback.vue?vue&type=script&lang=js"
import style0 from "./AppEditPostback.vue?vue&type=style&index=0&id=f5bd6cae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bd6cae",
  null
  
)

export default component.exports